import _slicedToArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useEffect } from 'react';
import { setToString } from '../../core/utilities/set.utils.js';
import { iterToSet } from '../../core/utilities/transform.utils.js';

function getBrowserClasses() {
  var possibleNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
  var _navigator = navigator,
      userAgent = _navigator.userAgent;

  if (userAgent.indexOf('Safari/') !== -1 && userAgent.indexOf('Chrome/') === -1 && userAgent.indexOf('Chromium/') === -1) {
    possibleNames.add('swan-safari');
  }

  if (userAgent.indexOf('Firefox/') !== -1 && userAgent.indexOf('Seamonkey/') === -1) {
    possibleNames.add('swan-firefox');
  }

  if (userAgent.indexOf('Edg/') !== -1) {
    // Chromium-based Edge
    possibleNames.add('swan-edge') // this gets put on ANY version of Edge
    ;
  }

  return possibleNames;
}

function useBrowserClasses(autoSyncWithHead, initialClassNames) {
  var _useState = useState(function () {
    return setToString(iterToSet(initialClassNames));
  }),
      _useState2 = _slicedToArray(_useState, 2),
      browserClassName = _useState2[0],
      setBrowserClassName = _useState2[1];

  useEffect(function () {
    setBrowserClassName(setToString(getBrowserClasses(iterToSet(initialClassNames))));
  }, [initialClassNames]);
  useEffect(function () {
    if (autoSyncWithHead && browserClassName) {
      try {
        var head = document.querySelector('head');
        head === null || head === void 0 ? void 0 : head.classList.add(browserClassName);
        return function () {
          return head === null || head === void 0 ? void 0 : head.classList.remove(browserClassName);
        };
      } catch (e) {
        console.info('Could not sync browser class name.');
      }
    }
  }, [browserClassName, autoSyncWithHead]);
  return browserClassName;
}

export { useBrowserClasses };